import { getLocales } from '@constants';

export const getTranslation = (prefix: string, myLocales?: { [key: string]: string }) => (id: string, params?: { [key: string]: string | number }) => {
	const locales = myLocales || getLocales();
	const localeText = locales[`${prefix}.${id}`] || '';

	if (params == null) {
		return localeText;
	} else {
		return Object.keys(params)
			.reduce(
				(result: string, key: string) => result.replace(new RegExp(`\{\{${key}\}\}`, 'g'), String(params[key])),
				localeText,
			);
	}
};

export const translations = {
	// общие термины
	common: getTranslation('base.utils.localization'),
	// термины используемые для игр
	appCatalog: getTranslation('base.utils.localization.appCatalog'),
};
